import React from 'react';
import PropTypes from 'prop-types';
import { Container, Label } from './css';
import SvgIcon from '../../icons/SvgIcon';

const TertiaryButton = ({
  label, size, icon, iconSrc, iconSrcDisabled, showArrow = true, isIconLeftPosition, ...rest
}) => (
  <Container
    onMouseUp={(e) => e.target.blur()}
    iconSrc={iconSrc}
    iconSrcDisabled={iconSrcDisabled}
    $showArrow={showArrow}
    {...rest}
  >
    {(icon && isIconLeftPosition) ? <SvgIcon className="left-icon" icon={icon} /> : null}
    <Label
      size={size}
      iconSrc={iconSrc}
      iconSrcDisabled={iconSrcDisabled}
      $showArrow={showArrow}
      isIconLeftPosition={isIconLeftPosition}
    >
      {label}
    </Label>
    {(icon && !isIconLeftPosition) ? <SvgIcon className="right-icon" icon={icon} /> : null}
  </Container>
);

TertiaryButton.propTypes = {
  label: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  iconSrc: PropTypes.string,
  iconSrcDisabled: PropTypes.string,
  showArrow: PropTypes.bool,
  isIconLeftPosition: PropTypes.bool,
};

export default TertiaryButton;
